import { Notification, TextLink } from '@dtpk-cc/components';

export const CustomerSourceNotSupportedError = () => (
    <Notification
        variant={Notification.Variant.warning}
        closable={false}
        noSideMargins
        noBottomMargin
        data-test-error="customer_source_not_supported_error"
    >
        <Notification.Headline>Sie sind bereits MagentaZuhause Regio Kunde?</Notification.Headline>
        <Notification.CopyText>
            Bitte loggen Sie sich mit Ihren Zugangsdaten im{' '}
            <TextLink href="https://www.telekom.de/kundencenter-breitband" target="_blank" rel="noreferrer">
                Kundencenter Breitband
            </TextLink>{' '}
            ein.
        </Notification.CopyText>
        <br />
        <Notification.Headline>Sie sind Zuhause Kabel Surfen u. Telefonieren Kunde?</Notification.Headline>
        <Notification.CopyText>Bitte wenden Sie sich an unseren Kundenservice.</Notification.CopyText>
    </Notification>
);
